/** Central contact info for Truck Company Center. */
export const CONTACT = {
  phoneE164: "+17867214284",
  phoneDisplay: "+1 (786) 721-4284",
  whatsappUrl:
    "https://wa.me/17867214284?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20Truck%20Company%20Center.",
  whatsappSupportUrl:
    "https://wa.me/17867214284?text=Hola%2C%20soy%20cliente%20de%20Truck%20Company%20Center.%20Necesito%20ayuda%20con%20mi%20formulario%20o%20pedido.",
} as const;
